export const faqIds = ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7']